/*
  DC PDP v2 — assets/dc-pdp.js (Builder A). Loaded with `defer` from sections/product-template.liquid.
  Needs window.dcPdpOpts (inline core in snippets/dc-pdp-options.liquid).

  C3 contract: keeps window.dcPdpState current and dispatches document CustomEvent 'dc:pdp:state' on every change with
    { variantId, available, soldOutProduct, price (cents, effective incl. selling plan), oncePrice, compareAt, qty,
      planId, planName, planInterval, sizeLabel, grindLabel, shortLabel, image, title, handle, total,
      perDelivery (cents per delivery: differs from price only on prepaid plans) }.

  Variant changes: theme.Product.prototype.productPage is wrapped (it fires after theme.js has updated #ProductPrice,
  #AddToCart and [name=id], on every path: initial load, pills, native selects, history popstate). Seal changes are
  read from its hidden input[name=selling_plan] after its own handlers ran. Nothing here posts to the cart: the only
  add path is the real product form (#AddToCart).
*/
(function () {
  'use strict';
  var sec = document.getElementById('ProductSection');
  var O = window.dcPdpOpts;
  if (!sec) return;
  var cfg = window.dcPdpConfig || {};
  var form = sec.querySelector('form[action^="/cart/add"]');
  var atc = document.getElementById('AddToCart');
  var atcTotal = sec.querySelector('[data-dcv-atc-total]');
  var priceEl = document.getElementById('ProductPrice');
  var wasEl = sec.querySelector('[data-dcv-was]');
  var unitEl = sec.querySelector('[data-dcv-unit]');
  var noplan = sec.querySelector('[data-dcv-noplan]');
  var dispatchEl = sec.querySelector('[data-dcv-dispatch]');
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function mq(q) { try { return window.matchMedia(q); } catch (e) { return { matches: false, addListener: function () {} }; } }
  function onMq(m, fn) { if (m.addEventListener) m.addEventListener('change', fn); else if (m.addListener) m.addListener(fn); }
  function warn(e) { if (window.console && console.warn) console.warn('dc-pdp', e); }

  /* ---------------- state (C3) ---------------- */
  var last = '';
  var t0 = 0;
  function qty() {
    var q = form && form.querySelector('[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }
  function planId() {
    var inp = form && form.querySelector('input[name="selling_plan"]');
    return inp && inp.value ? inp.value : null;
  }
  function recompute() {
    if (!O) return;
    try {
      var v = O.variant();
      var s = O.fullState(v, planId(), qty());
      if (atcTotal) atcTotal.textContent = s.total != null ? O.money(s.total) : '';
      if (wasEl) {
        if (s.planId && s.oncePrice != null && s.price < s.oncePrice) { wasEl.textContent = O.money(s.oncePrice); wasEl.hidden = false; }
        else { wasEl.hidden = true; wasEl.textContent = ''; }
      }
      if (unitEl) unitEl.textContent = O.unitText ? O.unitText(s, v) : '';
      if (dispatchEl) dispatchEl.hidden = !(v && v.available);
      noplanView(v);
      publish(s);
    } catch (e) { warn(e); }
  }
  function schedule() {
    clearTimeout(t0);
    t0 = setTimeout(recompute, 30);
  }
  function publish(s) {
    var key = JSON.stringify(s);
    if (key === last) return;
    last = key;
    window.dcPdpState = s;
    var ev;
    try { ev = new CustomEvent('dc:pdp:state', { detail: s }); }
    catch (e) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('dc:pdp:state', false, false, s); }
    document.dispatchEvent(ev);
  }

  /* greyed "Subscribe & save · free shipping — Available on …" row (owner decision 4).
     Liquid prints every size that has a plan somewhere (the no-JS text). When plans exist at the chosen weight but only for
     some grinds / bag formats, the row names those instead of a size the shopper already has ("Available on 1kg in Whole
     Beans", "Available on 1kg (4 × 250g bags)"). */
  var noplanSmall = noplan && noplan.querySelector('small');
  var noplanDefault = noplanSmall ? noplanSmall.textContent : '';
  function listJoin(a) { return a.length < 2 ? (a[0] || '') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function noplanText(v) {
    if (!O || !v || !O.P || !O.P.variants) return noplanDefault;
    var g = O.gramsOf(v), si = O.sizeIdx, gi = O.grindIdx;
    function opt(x, i) { return x.options ? x.options[i] : x['option' + (i + 1)]; }
    function sizeKey(x) { var gx = O.gramsOf(x); return gx != null ? 'g' + gx : 's' + String(si >= 0 ? opt(x, si) : '').split('(')[0].trim(); }
    var key = sizeKey(v), same = [];
    O.P.variants.forEach(function (x) { if (x.selling_plan_allocations && x.selling_plan_allocations.length && sizeKey(x) === key) same.push(x); });
    if (!same.length) return noplanDefault;
    var w = g ? O.weightLabel(v) : String(si >= 0 ? opt(v, si) : '').split('(')[0].trim();
    var fmts = [], grinds = [], seenF = {}, seenG = {};
    same.forEach(function (x) {
      if (si >= 0) { var f = opt(x, si); if (!seenF[f]) { seenF[f] = 1; fmts.push(f); } }
      if (gi >= 0) { var gr = opt(x, gi); if (!seenG[gr]) { seenG[gr] = 1; grinds.push(gr); } }
    });
    var myFmt = si >= 0 ? opt(v, si) : null, myGrind = gi >= 0 ? opt(v, gi) : null;
    var t = 'Available on ' + w;
    if (fmts.length && !seenF[myFmt]) {
      t += ' (' + fmts.map(function (f) { var fi = O.sizeInfo && O.sizeInfo[f]; return fi && fi.fmt ? O.pretty(fi.fmt) : f; }).join(' or ') + ')';
    }
    if (grinds.length && !seenG[myGrind]) {
      var allG = [];
      (O.P.variants || []).forEach(function (x) { var gr = opt(x, gi); if (allG.indexOf(gr) < 0) allG.push(gr); });
      var missing = allG.filter(function (x) { return grinds.indexOf(x) < 0; });
      t += grinds.length > 3 && missing.length <= 2 ? ' · all grinds except ' + listJoin(missing) : ' in ' + listJoin(grinds);
    }
    return t === 'Available on ' + w ? noplanDefault : t;
  }
  function noplanView(v) {
    if (!noplan) return;
    var hasPlan = !!(v && v.selling_plan_allocations && v.selling_plan_allocations.length);
    noplan.hidden = hasPlan;
    if (!hasPlan && noplanSmall) {
      var t = noplanText(v);
      if (noplanSmall.textContent !== t) noplanSmall.textContent = t;
    }
  }

  /* ---------------- variant hook ---------------- */
  function onVariant(variant) {
    if (O && variant) O.sync(variant);
    recompute();
    setTimeout(recompute, 60);
    setTimeout(recompute, 400);
  }
  (function hookTheme() {
    var T = window.theme && window.theme.Product && window.theme.Product.prototype;
    if (!T || typeof T.productPage !== 'function' || T.productPage.__dcv) return;
    var orig = T.productPage;
    T.productPage = function (o) {
      var r = orig.apply(this, arguments);
      try { onVariant(o && o.variant); } catch (e) { warn(e); }
      return r;
    };
    T.productPage.__dcv = true;
  })();

  /* ---------------- form listeners ---------------- */
  /* CODE-2 ("View cart →" reverts when the variant, quantity or selling plan changes) lives in theme.js
     (enableAjax: revertViewCartIfChanged, signature-based). It is not duplicated here, so re-clicking the
     plan that is already chosen keeps "View cart →". */
  /* quantity is a whole number >= 1 in the field itself, so what is posted is what the total shows ("2.5" -> 2) */
  function normQty(t) {
    if (!t) return;
    var n = parseInt(t.value, 10), v = String(n > 0 ? n : 1);
    if (t.value !== v) t.value = v;
  }
  if (form) {
    /* capture phase: runs before theme.js serialises the form on submit (Enter in the field, or #AddToCart) */
    document.addEventListener('submit', function (e) { if (e.target === form) normQty(form.querySelector('[name="quantity"]')); }, true);
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.sealsubs-target-element')) { setTimeout(recompute, 0); }
      if (t && t.name === 'quantity') normQty(t);
      schedule();
    });
    form.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') schedule(); });
    form.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.sealsubs-target-element')) {
        setTimeout(recompute, 0);
        setTimeout(recompute, 120);
      }
    });
  }
  if (window.MutationObserver) {
    if (priceEl) new MutationObserver(schedule).observe(priceEl, { childList: true, characterData: true, subtree: true });
    var sealT = form && form.querySelector('.sealsubs-target-element');
    if (sealT) new MutationObserver(schedule).observe(sealT, { childList: true, subtree: false, attributes: true, attributeFilter: ['class'] });
  }

  /* ---------------- dispatch line (Melbourne time, /pages/dispatch-schedule) ---------------- */
  function melbDow() {
    try {
      var wd = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', weekday: 'short' }).format(new Date());
      return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(wd.slice(0, 3));
    } catch (e) { return -1; }
  }
  function renderDispatch() {
    if (!dispatchEl || dispatchEl.hasAttribute('data-dcv-override')) return;
    var kind = dispatchEl.getAttribute('data-dcv-dispatch');
    if (kind === 'cartel' || kind === 'ml') return;
    var d = melbDow();
    if (d < 0) return;
    var day, note = '';
    if (kind === 'pillar') { day = d === 4 ? 'next Thursday' : 'Thursday'; note = ' (Pillar goes out Thursdays only)'; }
    else { day = (d >= 1 && d <= 3) ? 'Thursday' : 'Tuesday'; }
    var t = dispatchEl.querySelector('[data-dcv-dispatch-text]');
    if (t) t.innerHTML = 'Order today → dispatched <b>' + day + '</b> from our Melbourne warehouse' + note + ' · <a href="/pages/dispatch-schedule">Dispatch schedule</a>';
  }

  /* ---------------- gallery: mobile swipe strip + dots, desktop thumbs ---------------- */
  var strip = sec.querySelector('[data-dcv-strip]');
  var mobile = mq('(max-width: 749px)');
  function wrappers() { return strip ? Array.prototype.slice.call(strip.querySelectorAll('.product-single__featured-image-wrapper')) : []; }
  function setDot(id) {
    Array.prototype.forEach.call(sec.querySelectorAll('[data-dcv-dot]'), function (b) { b.setAttribute('aria-current', b.getAttribute('data-dcv-dot') === String(id) ? 'true' : 'false'); });
  }
  function setThumb(id) {
    Array.prototype.forEach.call(sec.querySelectorAll('#ProductThumbs .product-single__thumbnail'), function (a) {
      if (a.getAttribute('data-image-id') === String(id)) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
  }
  function scrollToImage(id, smooth) {
    if (!strip || !mobile.matches) return;
    var w = strip.querySelector('.product-single__featured-image-wrapper[data-image-id="' + id + '"]');
    if (!w) return;
    var left = w.offsetLeft;
    try { strip.scrollTo({ left: left, behavior: (smooth && !reduce) ? 'smooth' : 'auto' }); } catch (e) { strip.scrollLeft = left; }
    setDot(id);
  }
  /* the strip is a keyboard-scrollable region only on phones (where it scrolls); on wider screens it is not a tab stop */
  function stripA11y() {
    if (!strip || !strip.querySelector('.product-single__featured-image-wrapper + .product-single__featured-image-wrapper')) return;
    if (mobile.matches) { strip.setAttribute('tabindex', '0'); strip.setAttribute('role', 'region'); strip.setAttribute('aria-label', 'Product images'); }
    else { strip.removeAttribute('tabindex'); strip.removeAttribute('role'); strip.removeAttribute('aria-label'); }
  }
  stripA11y();
  onMq(mobile, stripA11y);
  if (strip) {
    var raf = 0;
    strip.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var ws = wrappers(), x = strip.scrollLeft, best = null, bd = 1e9;
        ws.forEach(function (w) { var dd = Math.abs(w.offsetLeft - x); if (dd < bd) { bd = dd; best = w; } });
        if (best) setDot(best.getAttribute('data-image-id'));
      });
    }, { passive: true });
    sec.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('[data-dcv-dot]') : null;
      if (b) scrollToImage(b.getAttribute('data-dcv-dot'), true);
    });
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          var w = m.target;
          if (w.classList && w.classList.contains('product-single__featured-image-wrapper') && !w.classList.contains('hidden') && m.oldValue && m.oldValue.indexOf('hidden') > -1) {
            var id = w.getAttribute('data-image-id');
            setThumb(id);
            scrollToImage(id, true);
          }
        });
      }).observe(strip, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
    }
  }

  /* ---------------- The details: open card on desktop, accordion on phones ---------------- */
  var spec = document.getElementById('dcvSpec');
  var desk = mq('(min-width: 900px)');
  if (spec) {
    onMq(desk, function () { spec.open = desk.matches; });
    spec.addEventListener('click', function (e) {
      if (desk.matches && e.target.closest && e.target.closest('summary') && e.target.closest('summary').parentNode === spec) e.preventDefault();
    });
  }

  /* ---------------- The story: "Read the full story" clamp on phones ---------------- */
  var body = document.getElementById('dcvStoryBody');
  var more = sec.querySelector('[data-dcv-more]');
  var expanded = false;
  function clampCheck() {
    if (!body || !more) return;
    if (desk.matches || expanded) { body.classList.remove('is-clamped'); more.hidden = !expanded || desk.matches; return; }
    body.classList.add('is-clamped');
    var over = body.scrollHeight > body.clientHeight + 8;
    if (!over) body.classList.remove('is-clamped');
    more.hidden = !over;
  }
  if (body && more) {
    more.addEventListener('click', function () {
      expanded = !expanded;
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      more.textContent = expanded ? 'Show less' : 'Read the full story';
      body.classList.toggle('is-clamped', !expanded);
      if (!expanded) clampCheck();
    });
    onMq(desk, clampCheck);
  }

  /* ---------------- sold-out: alternatives (Builder C fills #dcAlts) ---------------- */
  var alts = document.getElementById('dcAlts');
  var jumpN = sec.querySelector('[data-dcv-jump-n]');
  function altsSync() {
    if (!alts) return;
    var seen = {}, n = 0;
    Array.prototype.forEach.call(alts.querySelectorAll('a[href*="/products/"]'), function (a) {
      var h = (a.getAttribute('href') || '').split('?')[0];
      if (!seen[h]) { seen[h] = 1; n++; }
    });
    /* the fallback link and the heading belong to dc-pdp-taste.js (see noAlts below) */
    if (jumpN) jumpN.textContent = n > 0 ? ' · ' + n + ' similar coffee' + (n === 1 ? '' : 's') + ' in stock' : '';
  }
  if (alts && window.MutationObserver) new MutationObserver(altsSync).observe(alts, { childList: true, subtree: true });
  /* watchdog: if dc-pdp-taste.js never settles the panel (script blocked or failed to load), drop the skeleton and show the
     fallback link, like its own no-alternatives state */
  var soPanel = document.getElementById('dcSoldOutPanel');
  if (soPanel && !soPanel.hasAttribute('data-dc-alts-count')) {
    setTimeout(function () {
      if (soPanel.hasAttribute('data-dc-alts-count')) return;
      if (window.dcPdpTaste && typeof window.dcPdpTaste.noAlts === 'function') { window.dcPdpTaste.noAlts(soPanel); return; }
      try {
        var sk = soPanel.querySelectorAll('.dcv-alts__sk');
        for (var i = 0; i < sk.length; i++) sk[i].parentNode.removeChild(sk[i]);
        var ttl = soPanel.querySelector('[data-dc-alts-title]'); if (ttl) ttl.textContent = 'This one\u2019s sold out';
        var rs = soPanel.querySelector('[data-dc-alts-reason]'); if (rs) rs.textContent = '';
        var fb = soPanel.querySelector('[data-dc-alts-fallback]'); if (fb) { fb.hidden = false; if (fb.parentNode) fb.parentNode.hidden = false; }
        if (alts) alts.removeAttribute('aria-busy');
        soPanel.classList.remove('dcv-alts--loading');
        soPanel.setAttribute('data-dc-alts-count', '0');
        document.dispatchEvent(new CustomEvent('dc:taste:rendered', { detail: { mode: 'soldout', count: 0 } }));
      } catch (e) { warn(e); }
    }, 15000);
  }
  var jump = sec.querySelector('[data-dcv-jump]');
  if (jump) jump.addEventListener('click', function (e) {
    var p = document.getElementById('dcSoldOutPanel');
    if (!p) return;
    e.preventDefault();
    try { p.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); } catch (x) { p.scrollIntoView(); }
    try { p.focus({ preventScroll: true }); } catch (x) {}
  });

  /* Seal's space reservation runs inline right after the product form (sections/product-template.liquid): Seal's async
     script can mount before this deferred file runs. */

  /* ---------------- theme editor: a re-rendered product section needs a fresh page (all refs above are to the old DOM) ---------------- */
  document.addEventListener('shopify:section:load', function (e) {
    if (e && e.detail && e.detail.sectionId === (sec.getAttribute('data-section-id') || 'product-template')) window.location.reload();
  });

  /* ---------------- after theme.js has built the selects (jQuery ready runs after this deferred file) ---------------- */
  function afterThemeInit() {
    try {
      if (sec.classList.contains('dcv-pills-on')) {
        Array.prototype.forEach.call(sec.querySelectorAll('.selector-wrapper'), function (w) {
          w.setAttribute('aria-hidden', 'true');
          Array.prototype.forEach.call(w.querySelectorAll('select'), function (s) { s.setAttribute('tabindex', '-1'); });
        });
      }
      if (O && O.isPending()) O.drive();
    } catch (e) { warn(e); }
    renderDispatch();
    clampCheck();
    altsSync();
    recompute();
    /* Seal mounts asynchronously; settle once it has */
    setTimeout(recompute, 800);
    setTimeout(recompute, 2500);
  }
  if (window.jQuery) window.jQuery(function () { setTimeout(afterThemeInit, 0); });
  else if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterThemeInit);
  else afterThemeInit();
  window.addEventListener('pageshow', function (e) { if (e.persisted) recompute(); });
})();
